import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/platform`;
const LINKS_API = `${process.env.REACT_APP_BACKEND_URL}/api/links`;

const getAuthHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const platformApi = {
    // Stats
    getStats: async (token) => {
        const res = await axios.get(`${API}/stats`, { headers: getAuthHeader(token) });
        return res.data;
    },

    // Tenants
    getTenants: async (token, includeInactive = false) => {
        const res = await axios.get(`${API}/tenants?include_inactive=${includeInactive}`, { headers: getAuthHeader(token) });
        return res.data;
    },
    getTenant: async (token, id) => {
        const res = await axios.get(`${API}/tenants/${id}`, { headers: getAuthHeader(token) });
        return res.data;
    },
    createTenant: async (token, data) => {
        const params = new URLSearchParams({
            nombre: data.nombre,
            admin_email: data.admin_email,
            admin_nombre: data.admin_nombre,
            tenant_type: data.tenant_type || 'LAW_FIRM'
        });
        if (data.dominio) params.append('dominio', data.dominio);

        const res = await axios.post(`${API}/tenants?${params.toString()}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    updateTenant: async (token, id, data) => {
        const params = new URLSearchParams();
        if (data.nombre) params.append('nombre', data.nombre);
        if (data.dominio !== undefined) params.append('dominio', data.dominio);

        const res = await axios.put(`${API}/tenants/${id}?${params.toString()}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    toggleTenantStatus: async (token, id, active) => {
        const res = await axios.put(`${API}/tenants/${id}/status?activo=${active}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    assignPlan: async (token, tenantId, planId) => {
        const params = new URLSearchParams();
        if (planId) params.append('plan_id', planId);
        const res = await axios.put(`${API}/tenants/${tenantId}/plan?${params.toString()}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    resetTenantAdminPassword: async (token, tenantId) => {
        const res = await axios.post(`${API}/tenants/${tenantId}/reset-admin-password`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },

    // Users
    getTenantUsers: async (token, tenantId) => {
        const res = await axios.get(`${API}/tenants/${tenantId}/users`, { headers: getAuthHeader(token) });
        return res.data;
    },
    createTenantUser: async (token, tenantId, data) => {
        const params = new URLSearchParams({
            email: data.email,
            full_name: data.full_name,
            role: data.role
        });
        const res = await axios.post(`${API}/tenants/${tenantId}/users?${params.toString()}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    updateUserStatus: async (token, userId, active) => {
        const res = await axios.put(`${API}/users/${userId}/status?activo=${active}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    updateUserRole: async (token, userId, role) => {
        const res = await axios.put(`${API}/users/${userId}/role?role=${role}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    resetUserPassword: async (token, userId) => {
        const res = await axios.post(`${API}/users/${userId}/reset-password`, {}, { headers: getAuthHeader(token) });
        return res.data;
    },
    setUserPassword: async (token, userId, newPassword) => {
        const res = await axios.post(`${API}/users/${userId}/set-password`, { new_password: newPassword }, { headers: getAuthHeader(token) });
        return res.data;
    },

    // Plans
    getPlans: async (token) => {
        const res = await axios.get(`${API}/plans`, { headers: getAuthHeader(token) });
        return res.data;
    },
    createPlan: async (token, data) => {
        const res = await axios.post(`${API}/plans`, data, { headers: getAuthHeader(token) });
        return res.data;
    },
    updatePlan: async (token, id, data) => {
        const res = await axios.put(`${API}/plans/${id}`, data, { headers: getAuthHeader(token) });
        return res.data;
    },
    deletePlan: async (token, id) => {
        const res = await axios.delete(`${API}/plans/${id}`, { headers: getAuthHeader(token) });
        return res.data;
    },

    // Links (Uses LINKS_API but might have platform specific wrappers or just reuse)
    getAllLinks: async (token) => {
        // Super Admin sees all
        const res = await axios.get(LINKS_API, { headers: getAuthHeader(token) });
        return res.data;
    },
    updateLinkStatus: async (token, linkId, status) => {
        const res = await axios.put(`${LINKS_API}/${linkId}/status?status=${status}`, {}, { headers: getAuthHeader(token) });
        return res.data;
    }
};
